import { render } from "./HeroiconsSolidSave.vue?vue&type=template&id=207481d5"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSave.vue"]])

export default __exports__